<template>
  <header>
    <div class="navbar box-shadow btborder noprint">
      <div class="container d-flex justify-content-between">
        <router-link
          :to="{ name: 'dashboard' }"
          class="navbar-brand d-flex align-items-center"
        >
          <img src="@/assets/images/logo.png" class="logo" alt />
        </router-link>
      </div>
    </div>
  </header>
</template>
<script>
  import "../assets/scss/main.scss";
  import { mapGetters } from "vuex";
  export default {
    name: "HeaderApp",
    computed: mapGetters({
      itemTableOrder: "nav/itemTableOrder",
      products_Order: "nav/productionsOrder",
    }),
    data() {
      return {};
    },
    methods: {
      setCollapeItemOrder() {
        this.$store.dispatch("nav/collape_item_order", this.itemTableOrder);
        this.$store.dispatch("nav/collape_products_order", this.products_Order);
      },
    },
  };
</script>
<style lang="css" scoped>
  .logo {
    max-width: 150px;
  }
  .btborder {
    border-bottom: 2px solid #a9a9a95e;
  }
  .navbar {
    background-color: white;
  }

  ul .dropdown-menu {
    transform: translate3d(-125px, 20px, 0px);
  }
  .navbar-nav {
    flex-direction: row;
  }
  .block-header {
    height: 6%;
    margin-bottom: 3px;
    border-bottom: 1px solid black;
  }
  nav {
    height: 100%;
  }
  .zmdi {
    color: black;
  }
  ul {
    float: right;
  }

  .logo,
  .tiltle {
    font-weight: bold;
    color: white;
  }

  .logo a {
    text-decoration: none;
    color: rgb(139, 5, 5);
  }

  h2 {
    margin: auto;
  }
  li {
    margin: 0 16px;
  }
  .notify {
    position: absolute;
    top: 10px;
    right: 16px;
  }
  li a {
    text-decoration: none;
    color: white;
  }

  li a:hover,
  li a:active,
  li a.router-link-active {
    color: #fa923f;
  }

  .logout {
    background-color: transparent;
    border: none;
    font: inherit;
    color: white;
    cursor: pointer;
  }
  .clearfix {
    float: right;
  }
  .point,
  .heartbit,
  .notify {
    color: #f90e02;
    background-color: #f90e02;
  }
</style>
